import { useEffect, useState } from "react";
import LoaderHelper from "../../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../../context/AlertContext";
import AuthService from "../../../../../../api/AuthService";
import NotesHomePage from "../../../../../../entities/DashboardPage/AccountingModule/Customer/Notes/NotesHome";
import HomeSalesOrderPage from "../../../../../../entities/DashboardPage/AccountingModule/Customer/SalesOrder/HomeSalesOrder";

const HomeSales = () => {
  const { showAlert } = useAlert();
  const [salesOrderList, setSalesOrderList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAllSalesOrderList();

      if (result?.success) {
        setSalesOrderList(result?.data?.salesOrders);
        setTotal(result.data.total);
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result.message, "error");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      showAlert("Failed to load data", "error");
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleDeleteSalesOrder(id);
      if (result?.success) {
        showAlert(result.message, "success")
        fetchInitialData();
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result.message, "error")
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message)
    }
  };

  return (
    <>
      <HomeSalesOrderPage
        salesOrderList={salesOrderList}
        total={total}
        setTotal={setTotal}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        handleDelete={handleDelete}
      />
    </>
  );
};

export default HomeSales;
